import '.dd{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.de{padding-left:1.5rem;}.ssr-plugin'
import '.df{margin:1rem 0;}.ssr-plugin'
import '.dg{color:var(--gray-700);}.ssr-plugin'
import '.dh{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="dd de df dg dh"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
